import { render, staticRenderFns } from "./dashboardCard.vue?vue&type=template&id=4bcdf6cd&scoped=true"
import script from "./dashboardCard.vue?vue&type=script&lang=js"
export * from "./dashboardCard.vue?vue&type=script&lang=js"
import style0 from "./dashboardCard.vue?vue&type=style&index=0&id=4bcdf6cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcdf6cd",
  null
  
)

export default component.exports